import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from '../BaseComponent';

const DateTimeInput = ({
  name,
  value = '',
  isError = false,
  placeholder = '',
  onChange,
  onClick,
  onKeyUp,
  onFocus,
  onBlur,
  label,
  cssClass,
  id,
  disabled = false,
}) => {
  const handleChange = (e) => {
    !!onChange && onChange(e);
  };

  return (
    <BaseComponent name={'DateTimeInput'}>
      <div className="input-conatainer">
        {label ? <div className="input-label">{label}</div> : ''}
        <input
          name={name}
          type="datetime-local"
          className={`inputText ${isError ? ' border-error' : ''} ${cssClass}`}
          value={value}
          placeholder={placeholder}
          onChange={(e) => handleChange(e)}
          onClick={onClick}
          onKeyUp={onKeyUp}
          onFocus={onFocus}
          onBlur={onBlur}
          disabled={disabled}
          id={id}
          autoComplete="off"
        />
        {isError ? <div className="color-error error-text">{errorText}</div> : ''}
      </div>
    </BaseComponent>
  );
};

DateTimeInput.propTypes = {
  value: PropTypes.string,
  isError: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onKeyUp: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  label: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  cssClass: PropTypes.string,
  errorText: PropTypes.string,
};

export { DateTimeInput };


